import { Component, OnInit, inject } from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle
} from '@angular/material/dialog';
import {FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {combineLatest, isObservable, Observable} from 'rxjs';
import {delay, map, startWith, tap} from 'rxjs/operators';
import {StringService} from "../../../core/services/string.service";
import { AsyncPipe } from '@angular/common';
import {MatFormField, MatLabel, MatSuffix} from '@angular/material/form-field';
import {MatInput} from '@angular/material/input';
import {MatIcon} from '@angular/material/icon';
import {MatDivider} from '@angular/material/divider';
import {
    MatListItemAvatar,
    MatListItemLine,
    MatListItemTitle,
    MatListOption,
    MatSelectionList
} from '@angular/material/list';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatButton} from '@angular/material/button';
import {TranslateModule} from '@ngx-translate/core';
import {SafeHtmlPipe} from "../../../pipes/safeHtml.pipe";

export interface ModalSelectionListData {
    title?: string;
    helpContent?: string;
    dangerContent?: string;
    buttonLabel?: string;
    multiple?: boolean;
    required?: boolean;
    dense?: boolean;
    items: ModalSelectionListItem[] | Observable<ModalSelectionListItem[]>;
    enableSearch?: boolean;
    noData?: string;
}

export interface ModalSelectionListItem {
    label?: string;
    value: unknown;
    secondLine?: string;
    selected?: boolean;
    disabled?: boolean;
    avatar?: {
        type?: 'image' | 'text' | 'icon';
        src?: string;
        text?: string;
        icon?: string;
        bgcolor?: string;
    };
}


@Component({
    selector: 'app-modal-selection-list',
    templateUrl: './modal-selection-list.component.html',
    styleUrls: ['./modal-selection-list.component.scss'],
    imports: [
    MatDialogTitle,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    ReactiveFormsModule,
    MatIcon,
    MatSuffix,
    MatDivider,
    MatDialogContent,
    MatSelectionList,
    MatListOption,
    MatListItemAvatar,
    MatListItemTitle,
    MatListItemLine,
    MatProgressSpinner,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    AsyncPipe,
    TranslateModule,
    SafeHtmlPipe
]
})
export class ModalSelectionListComponent implements OnInit {
    data = inject<ModalSelectionListData>(MAT_DIALOG_DATA);
    private stringService = inject(StringService);


    public form: UntypedFormGroup;
    public items$: Observable<ModalSelectionListItem[]>;
    public filteredItems$?: Observable<ModalSelectionListItem[]>;

    filter: UntypedFormControl = new UntypedFormControl('');
    filter$?: Observable<string>;

    constructor() {
        const data = this.data;

        this.data = {
            ...data,
            multiple: data.multiple ?? false,
            noData: data.noData ?? 'Aucun élément ne peut être affiché avec ce critère'
        };


        // if (data.enableSearch && data.multiple) {
        //     throw new Error('enableSearch=true and multiple=true : compatibility not implemented');
        // }

        const selection: UntypedFormControl = new UntypedFormControl();

        const dataItems = data.items;
        let item$: Observable<ModalSelectionListItem[]>;
        if (isObservable(dataItems)) {
            item$ = dataItems;
        } else {
            item$ = new Observable((observer) => {
                observer.next(dataItems);
            });
        }
        this.items$ = item$.pipe(
            delay(100), // évite un bug graphique : permet à la modale de s'ouvriravant chargement
            tap(item => console.log(item)),
            tap(item => selection.patchValue(item.filter(elt => elt.selected)))
        );

        this.filter$ = this.filter.valueChanges.pipe(startWith(''));
        this.filteredItems$ = combineLatest([this.items$, this.filter$]).pipe(
            map(
                ([items, filterString]) => items.filter(
                    item => this.stringService.stringIncludes(item.label + ' ' + item.secondLine, filterString)
                )
            )
        );

        const validators = [];
        if (data.required) {
            validators.push(Validators.required);
        }
        selection.setValidators(validators);

        this.form = new UntypedFormGroup(
            {
                selection
            }
        );
    }

    ngOnInit(): void {
    }
}
